import { IMAGES } from "@/lib/brand";
import { useReveal } from "@/lib/useReveal";
import { Check } from "lucide-react";

const POINTS = [
  "Tehnici profesionale de aplicare uniformă",
  "Diagnoză a tipului de piele înainte de fiecare ședință",
  "Produse premium Norvell & Sjolie",
  "Studio modern, curat, intimitate garantată",
];

export default function About() {
  const r = useReveal();
  return (
    <section
      id="despre"
      data-testid="about-section"
      className="py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 grid lg:grid-cols-12 gap-12 items-center">
        <div ref={r.ref} className={`lg:col-span-5 ${r.className}`}>
          <div className="img-zoom rounded-[2rem] overflow-hidden border border-[#D7B899]/40 bg-[#F5E6D3]">
            <img
              src={IMAGES.about}
              alt="Studio premium spray tan"
              className="w-full h-auto block"
              data-testid="about-image"
            />
          </div>
        </div>
        <div className="lg:col-span-7 lg:pl-10 space-y-7">
          <div className="section-label">Despre noi</div>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-[#3B2A22] leading-[1.05]">
            Frumusețe, încredere și un{" "}
            <em className="italic text-[#B88746]">bronz perfect</em>
          </h2>
          <p className="text-[#3B2A22]/75 leading-relaxed max-w-xl">
            La The Best Bronze credem că un bronz frumos trebuie să fie și sigur.
            Misiunea noastră este să oferim rezultate profesionale folosind produse
            premium și tehnici moderne pentru un aspect impecabil și natural.
          </p>
          <ul className="space-y-3 pt-2">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3 text-[#3B2A22]">
                <span
                  className="mt-1 w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
                  style={{ background: "#B88746", color: "#FFFDF9" }}
                >
                  <Check size={12} strokeWidth={2.5} />
                </span>
                <span className="text-sm sm:text-base">{p}</span>
              </li>
            ))}
          </ul>
          <div className="pt-4">
            <a href="#rezervare" data-testid="about-cta" className="btn-primary">
              Programează o ședință
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
